import { NavigationGuard, RouteLocationNormalized } from 'vue-router';
import { useLoginStore } from '@stores/login';

export const validateRouteAndNavigate = (route: RouteLocationNormalized): ReturnType<NavigationGuard> => {
	const loginStore = useLoginStore();

	if (route.name === 'login-two-factor-select' && loginStore.twoFactorMetadata?.twoFactorType === 'TOTP') {
		return { name: 'login-two-factor-confirm', replace: true };
	}

	if (route.name === 'login-two-factor-confirm' && loginStore.selectedTwoFactorCodeDeliveryMethod === 'NONE') {
		return { name: 'login-two-factor-select' };
	}
};
